// A file drag that no drop field claims makes the browser open the file in a new tab
// (@adr SPARK-0022-file-drop-fields@4). Fields claim theirs before the event bubbles up here, so
// only what reaches the document unclaimed is refused; drags without files stay free for the
// app's own item drag-and-drop.
//
// An iframe is a document of its own, so a drop on one never reaches this guard. While a file
// drag is over the app, `data-file-drag` on <html> makes iframes transparent to it (index.css);
// dragover keeps firing while the drag lasts, so the marker clears on a heartbeat once it stops.
//
// Longer than a drop field's 450 ms: with the cursor at rest, browsers may fire dragover only every
// 350 ± 200 ms, and a marker that lapses over an iframe never comes back — the iframe then takes the
// drag and opens the file.
export const MARK_HEARTBEAT_MS = 1_000;

export function installFileDropGuard(): () => void {
  const root = document.documentElement;
  let heartbeat: ReturnType<typeof setTimeout> | undefined;

  const endDrag = () => {
    clearTimeout(heartbeat);
    delete root.dataset.fileDrag;
  };
  const markDrag = (e: DragEvent) => {
    if (!e.dataTransfer?.types.includes("Files")) return;
    root.dataset.fileDrag = "";
    clearTimeout(heartbeat);
    heartbeat = setTimeout(endDrag, MARK_HEARTBEAT_MS);
  };
  const refuse = (e: DragEvent) => {
    if (e.defaultPrevented || !e.dataTransfer?.types.includes("Files")) return;
    e.preventDefault();
    e.dataTransfer.dropEffect = "none";
  };

  // Marking captures, so a drop field that stops the drag from bubbling cannot hide it.
  document.addEventListener("dragover", markDrag, true);
  document.addEventListener("drop", endDrag, true);
  document.addEventListener("dragover", refuse);
  document.addEventListener("drop", refuse);
  return () => {
    document.removeEventListener("dragover", markDrag, true);
    document.removeEventListener("drop", endDrag, true);
    document.removeEventListener("dragover", refuse);
    document.removeEventListener("drop", refuse);
    endDrag();
  };
}
